import { generatePath, matchPath } from "react-router-dom";
import ROUTES from "navigation/routes";
import { EVENT_TYPE, EventTypes, SCREEN_NAMES } from "./analytics";

export const redirectToRootRoute = (history: any, path: string) => {
  let newRoute = "/";
  const map: any = {
    "/nutrition/food-log": ROUTES.NUTRITION_FOOD_LOG,
    "/nutrition/search": ROUTES.NUTRITION_FOOD_LOG,
    "/nutrition/recipe-library": ROUTES.NUTRITION_RECIPE_LIBRARY,
    "/nutrition/my-items/my-recipes": ROUTES.NUTRITION_MY_ITEMS_MY_RECIPES,
    "/nutrition/my-items/my-food": ROUTES.NUTRITION_MY_ITEMS_MY_FOOD,
    "/nutrition/my-items/favorites": ROUTES.NUTRITION_MY_ITEMS_FAVORITES,
    "/today": ROUTES.TODAY,
    "/workout/categories": ROUTES.WORKOUT,
    "/resources": ROUTES.RESOURCES,
    "/calendar": ROUTES.CALENDAR,
  };

  for (const prop in map) {
    if (path.includes(prop)) {
      newRoute = map[prop];
    }
  }

  history.push(generatePath(newRoute));
};

const matchRoute = (pathname: string, route: string) => {
  return matchPath(route, pathname);
};

export const getScreenName = (pathname: string) => {
  switch (pathname) {
    case ROUTES.SIGN_IN:
      return SCREEN_NAMES.SIGN_IN;
    case ROUTES.FORGOT_PASSWORD:
      return SCREEN_NAMES.FORGOT_PASSWORD;
    case ROUTES.WORKOUT:
      return SCREEN_NAMES.WORKOUT;
    case ROUTES.WORKOUT_CATEGORY_DETAILS:
      return SCREEN_NAMES.WORKOUT_CATEGORY_DETAILS;
    case ROUTES.CALENDAR:
      return SCREEN_NAMES.CALENDAR;
    case ROUTES.WORKOUT_FAVORITES:
      return SCREEN_NAMES.WORKOUT_FAVORITES;

    default:
      break;
  }

  if (matchRoute(pathname, ROUTES.WORKOUT_CATEGORY_DETAILS)) {
    return SCREEN_NAMES.WORKOUT_CATEGORY_DETAILS;
  }

  if (matchRoute(pathname, ROUTES.WORKOUT_CATEGORY_DETAILS_WORKOUTS)) {
    return SCREEN_NAMES.WORKOUT_CATEGORY_BY_DAY;
  }

  if (matchRoute(pathname, ROUTES.WORKOUT_CATEGORY_DETAILS_WORKOUT_DETAILS)) {
    return SCREEN_NAMES.WORKOUT_DETAILS;
  }

  if (
    matchRoute(
      pathname,
      ROUTES.WORKOUT_CATEGORY_DETAILS_WORKOUTS_WORKOUT_DETAILS,
    )
  ) {
    return SCREEN_NAMES.WORKOUT_DETAILS;
  }

  if (
    matchRoute(
      pathname,
      ROUTES.WORKOUT_CATEGORY_DETAILS_WORKOUT_DETAILS_MOVEMENT_DETAILS,
    ) ||
    matchRoute(
      pathname,
      ROUTES.WORKOUT_CATEGORY_DETAILS_WORKOUTS_WORKOUT_DETAILS_MOVEMENT_DETAILS,
    ) ||
    matchRoute(pathname, ROUTES.TODAY_WORKOUT_DETAILS_MOVEMENT_DETAILS) ||
    matchRoute(
      pathname,
      ROUTES.CALENDAR_WORKOUT_SCHEDULE_DATE_DETAILS_MOVEMENT_DETAILS,
    )
  ) {
    return SCREEN_NAMES.MOVEMENT_DETAILS;
  }

  if (matchRoute(pathname, ROUTES.WORKOUT_FAMILY_DETAILS)) {
    return SCREEN_NAMES.WORKOUT_FAMILY;
  }

  return "";
};

type AnalyticsTrackingResult = {
  params: {
    id?: any;
    date?: string;
    title?: any;
  };
  eventName: EventTypes;
} | null;

export const trackAnalyticsScreenParams = (
  name: string,
  params: any,
): AnalyticsTrackingResult => {
  const date = new Date()?.toISOString();

  switch (name) {
    case "Workout Category Details":
      return {
        params: { date, ...params },
        eventName: EVENT_TYPE.WORKOUT_CATEGORY,
      };

    case "Workout Details":
      return {
        params: { date, ...params },
        eventName: EVENT_TYPE.WORKOUT_DETAILS,
      };

    case "Workout Category By Day":
      return {
        params: { date, ...params },
        eventName: EVENT_TYPE.WORKOUT_CATEGORY_BY_DAY,
      };

    case "Movement Details":
      return {
        params: { date, ...params },
        eventName: EVENT_TYPE.WORKOUT_MOVEMENT,
      };

    default:
      return null;
  }
};
